<template>
  <div>
    <div v-if="selectedItems?.length" :name="$t('filters.selected.label')">
      <div>
        <pdl-section-header size="sm" :is-non-stacking="true" class="mb-2 show-for-large">
          <template #content>
            <pdl-heading>{{ $t('filters.selected.label') }}</pdl-heading>
          </template>

          <template #actions>
            <div v-show="selectedItems?.length" class="cursor-pointer font-normal text-sm my-0">
              <button @click="clearFilters">
                {{ $t('search.nav.clearSelections') }}
              </button>
            </div>
          </template>
        </pdl-section-header>
      </div>

      <ul class="facet-group__list pt-25">
        <li
          v-for="item in selectedItems"
          :key="item.id"
          class="facet-group__list-item mb-25"
          :class="{'is-active': activeFilters.indexOf(item.id) > -1}"
          :name="item.id"
        >
          <form class="flex justify-between label-selected">
            <label
              v-if="item.type === 'color'"
              role="button"
              tabindex="0"
              class="cursor-pointer flex grow md:mb-1 items-center"
              :for="item.id"
              @click="updateFilters(item)"
              @keyup.enter="updateFilters(item)"
              ><span class="sr-only">color: ${{ item.text }}</span>
              <pdl-swatch
                :name="item.id"
                :first-color="getColorFromCode(item.id, 0)"
                :second-color="getColorFromCode(item.id, 1)"
              />
              <em>{{ item.text }}</em>
            </label>

            <label v-else class="cursor-pointer grow pl-1" :for="item.id">
              <button class="w-full" @click.prevent="updateFilters(item)">
                <em>{{ item.text }}</em>
              </button>
            </label>

            <div class="facet-group__row-right flex items-center">
              <input :id="item.id" class="facet-group__check" type="checkbox" />
              <pdl-button
                v-show="item.active"
                qaid="remove-filter-button"
                class="-ml-1"
                button
                tertiary
                icon="cancel"
                icon-only
                @click.prevent="updateFilters(item)"
              />
            </div>
          </form>
        </li>
      </ul>

      <pdl-button secondary block type="button" class="hide-for-large my-2" @click="clearFilters">
        {{ $t('search.nav.clearSelections') }}
      </pdl-button>
    </div>

    <pdl-collapse-item v-for="group in filterGroups" :key="group.label" :name="group.label">
      <template #title>
        <pdl-heading size="sm">{{ group.label }}</pdl-heading>
      </template>

      <ul class="facet-group__list">
        <li
          v-for="item in group.items"
          :key="item.id"
          class="facet-group__list-item mb-25"
          :class="{'is-active': activeFilters.indexOf(item.id) > -1}"
          :name="item.id"
        >
          <form class="flex justify-between label-selected">
            <label
              v-if="item.type === 'color'"
              role="button"
              tabindex="0"
              class="cursor-pointer flex grow md:mb-1 items-center"
              :for="item.id"
              @click.prevent="updateFilters(item)"
              @keyup.enter.prevent="updateFilters(item)"
              ><span class="sr-only">color: ${{ item.text }}</span>
              <pdl-swatch
                :name="item.id"
                :first-color="getColorFromCode(item.id, 0)"
                :second-color="getColorFromCode(item.id, 1)"
              />
              <em>{{ item.text }}</em>
            </label>

            <label v-else class="cursor-pointer grow pl-1" :for="item.id">
              <button class="w-full" @click.prevent="updateFilters(item)">
                <em>{{ item.text }}</em>
              </button>
            </label>

            <div class="facet-group__row-right flex items-center">
              <input :id="item.id" class="facet-group__check" type="checkbox" />
              <pdl-button
                v-show="item.active"
                tertiary
                icon-only
                class="facet-group__decorator-refinement"
                :icon="'done'"
                @click.prevent="updateFilters(item)"
              />
            </div>
          </form>
        </li>
      </ul>
    </pdl-collapse-item>
  </div>
</template>

<script>
import {PdlCollapseItem} from '@pedal/pdl-collapse';
import {PdlSwatch} from '@pedal/pdl-swatch';
import swatchMixin from '@/mixins/swatches.js';
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';
import {PdlButton} from '@pedal/pdl-button';
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
  name: 'FilterGroup',
  componentName: 'FilterGroup',
  components: {PdlSwatch, PdlCollapseItem, PdlSectionHeader, PdlHeading, PdlButton},
  mixins: [swatchMixin],

  computed: {
    ...mapState('filterGroup', ['activeFilters', 'filterGroups']),
    ...mapGetters('filterGroup', ['selectedItems']),
  },
  methods: {
    ...mapMutations('filterGroup', ['updateFilters', 'clearFilters']),
  },
};
</script>

<style scoped>
.facet-group__list-item label {
  display: flex;
  align-items: center;
}

.facet-group__decorator-refinement {
  color: black;
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 16' version='1.1' fill='#999999' width='12' height='16' aria-hidden='true'%3E%3Cpath fill-rule='evenodd' d='M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5L12 5z'%3E%3C/path%3E%3C/svg%3E");
  top: 50%;
  transform: translateY(-50%);
}

.facet-group__decorator-refinement::before,
.facet-group__decorator-refinement::after {
  display: none;
}

.facet-group__row-right i {
  padding-top: 0;
}
</style>
